import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TicketStatusTransition } from '../../models/ticket-status-transition.model';
import { LocalStorageService } from '../../storage/local-storage/local-storage.service';
import { Appointment } from './../../models/appointment.model';

@Injectable({
	providedIn: 'root'
})
export class TicketStatusTransitionsService {

	updates$ = new BehaviorSubject<Appointment>(null);

	constructor(
		public storageService: LocalStorageService
	) { }

	async getStatusTransition(id: number | string): Promise<TicketStatusTransition> {
		return await this.storageService.ticketStatusTransitions.getItem<TicketStatusTransition>(`${id}`);
	}

	setUpdated(appointment: Appointment) {
		this.updates$.next(appointment);
	}
}
